module.exports = __webpack_public_path__ + "img/Physcomitrella_patens.02971a98.jpg";